<template>
  <div>
    <!-- 导航条 -->
    <top-nav></top-nav>
    <!-- 轮播图片 -->
    <div
      id="carouselExampleInterval"
      class="carousel slide"
      data-ride="carousel"
    >
      <div class="carousel-inner">
        <div
          :class="['carousel-item', index === 0 ? 'active' : '']"
          v-for="(item, index) in bannerList"
          :key="item.Id"
          data-interval="3000"
        >
          <img :src="item.CompanyName" class="d-block w-100" />
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleInterval"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleInterval"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <!-- 广场动态 -->
    <div class="dynamic_wrap type_area">
      <div class="dynamic_title">
        <div>广场动态</div>
        <div>Square dynamic</div>
      </div>
      <!-- 内容 -->
      <div class="card-group dynamic_item_wrap">
        <div
          class="card dynamic_item"
          v-for="item in dynamicList"
          :key="item.Id"
          style="border: none;"
          @click="handleDetailsPage(item.Id, item.SxType)"
        >
          <div style="margin: auto;">
            <img :src="item.CompanyPhone" class="card-img-top" />
            <div class="card-body">
              <div class="card-title item_title">
                {{ item.CompanyName }}
              </div>
              <div class="item_time">{{ item.IssueTime.substr(0, 10) }}</div>

              <div class="card-text item_content" v-html="item.Remarks"></div>

              <div class="item_arrows">→</div>
            </div>
          </div>
        </div>
      </div>

      <div class="see_more" @click="handleSquarePage">查看更多</div>
    </div>
    <!-- 入驻品牌 -->
    <div class="brand_wrap">
      <div class="dynamic_wrap type_area">
        <div class="dynamic_title">
          <div>入驻品牌</div>
          <div>Settled brands</div>
        </div>

        <div class="cut_tier_wrap">
          <div
            v-for="(item, index) in floorList"
            :key="item.Id"
            :class="[
              'tier_item',
              enterCurrentIndex === index ? 'enter_active' : ''
            ]"
            @click="handleEnterActive(item, index)"
          >
            {{ item.CompanyName }}
          </div>
        </div>
        <div class="show_wrap" @click="handleSettledPage">
          <!-- <div class="cut_show_title">{{ floorActive }}</div> -->
          <img :src="floorActive.RzhuPic" class="img-fluid" />
        </div>
      </div>
    </div>
    <!-- 品牌招商 -->
    <div class="merchants_wrap">
      <div class="dynamic_wrap type_area">
        <div class="dynamic_title">
          <div>品牌招商</div>
          <div>attract investment</div>
        </div>

        <div class="card-group merchants_item_box">
          <!-- 每一项 -->
          <div
            class="card merchants_item"
            v-for="(item, index) in merchantsList"
            :key="item.Id"
            style="border: none;"
          >
            <img
              class="merchant_number"
              v-if="index === 0"
              src="../../assets/index_img/merchant_01.png"
            />
            <img
              class="merchant_number"
              v-if="index === 1"
              src="../../assets/index_img/merchant_02.png"
            />
            <img
              class="merchant_number"
              v-if="index === 2"
              src="../../assets/index_img/merchant_03.png"
            />
            <div class="transverse_line"></div>

            <div class="card-body" style="padding: 0;">
              <div class="advantage_title" @click="handleBrandPage">
                {{ item.CompanyName }}
              </div>
              <div class="item_content" v-html="item.CompanyLogo"></div>
              <img @click="handleBrandPage" :src="item.CompanyPhone" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from '../../components/top-nav'
import bottomFooter from '../../components/bottom-footer'
export default {
  components: { topNav, bottomFooter },

  data() {
    return {
      // 轮播图数据
      bannerList: [],
      // 广场动态
      dynamicList: [],
      // 品牌招商
      merchantsList: [],
      // 入驻品牌楼层
      floorList: [],
      // 入驻品牌详情
      floorActive: {},
      // 入驻品牌层切换
      enterCurrentIndex: 0
    }
  },

  created() {
    this.getIndexData()
    this.getBrandFloorList()
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      this.getBannerList(2)
    } else {
      this.getBannerList(1)
    }
  },

  methods: {
    // 获取顶部大图
    async getBannerList(showTo) {
      const { data: res } = await this.$request.post(
        `/SX_Company/GetBannerList?SxType=${this.$route.query.id ||
          20}&ShowTo=${showTo}`
      )

      this.bannerList = res.data
    },

    // 首页数据
    async getIndexData() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetHomeDataList'
      )
      this.dynamicList = res.data.GuangChangNew
      res.data.PinPaiNew.forEach(item => {
        if (this.merchantsList.length < 3) {
          this.merchantsList.push(item)
        }
      })
    },

    // 入驻品牌楼层
    async getBrandFloorList() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetHomeRzhuPicList'
      )
      this.floorList = res.data

      this.floorActive = res.data[0]
    },

    // 入驻品牌层切换
    async handleEnterActive(item, index) {
      this.floorActive = item
      this.enterCurrentIndex = index
    },

    // 广场动态查看更多
    handleSquarePage() {
      this.$router.push({
        path: '/square-dynamic',
        query: {
          id: this.dynamicList[0].SxType
        }
      })
    },

    // 广场动态跳转到详情页
    handleDetailsPage(id, SxType) {
      const routeURL = this.$router.resolve({
        path: '/square-details',
        query: {
          id: SxType,
          detailsId: id
        }
      })

      window.open(routeURL.href, '_blank')
    },

    // 跳转到入驻品牌页面
    handleSettledPage() {
      this.$router.push({
        path: '/settled-brand',
        query: {
          id: 155,
          sonId: this.floorActive.Id
        }
      })
    },

    // 跳转品牌招商页面
    handleBrandPage() {
      this.$router.push({
        path: '/brand-merchants',
        query: {
          id: 156
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
// 轮播图片
// .carousel_img_wrap {
//   img {
//     height: 700px;
//   }
// }

// 通用
.dynamic_wrap {
  padding: 70px 0;

  .dynamic_title {
    text-transform: uppercase;
    text-align: center;
    div:nth-child(1) {
      padding-bottom: 17px;
      font-size: 30px;
      color: #b92e32;
    }

    div:nth-child(2) {
      align-items: center;
      font-size: 16px;
      color: #999;
    }
  }
}

// 广场动态
.dynamic_item_wrap {
  padding: 50px 0;

  .dynamic_item {
    width: 395px;
    display: flex;
    flex: none;
    flex-wrap: wrap;
    font-size: 14px;
    transition: all 0.2s linear;
    cursor: pointer;

    img {
      margin-top: 15px;
      width: 355px;
      height: 193px;
    }

    .card-body {
      padding: 0;
      margin-top: 20px;
    }

    .item_title {
      width: 355px;
      font-size: 16px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 23px 0 11px;
      margin-bottom: 0;
    }

    .item_time {
      width: 355px;
      color: #999;
    }

    .item_content {
      width: 355px;
      line-height: 25px;
      margin: 20px 0 30px;
      color: #666;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3; /*截取第三行*/
      overflow: hidden;
    }

    .item_arrows {
      width: 355px;
      text-align: right;
      font-size: 20px;
      color: #858585;
      padding-bottom: 28px;
    }
  }

  .dynamic_item:hover {
    box-shadow: 0px 0px 20px #ccc;
    transition: all 0.2s linear;
    .item_title {
      color: #b92e32;
    }
  }
}

// 查看更多
.see_more {
  width: 138px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border: 1px solid #b92e32;
  border-radius: 3px;
  font-size: 16px;
  margin: auto;
  color: #b92e32;
  cursor: pointer;
  transition: all 0.2s linear;
}

.see_more:hover {
  transition: all 0.2s linear;
  color: #fff;
  background-color: #b92e32;
}

// 入驻品牌
.brand_wrap {
  // width: 100vw;
  background-color: #f7f7f7;

  .cut_tier_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 70px 0 60px;
    .tier_item {
      padding: 0 28px;
      margin: 0 45px;
      font-size: 16px;
      color: #333;
      cursor: pointer;
    }

    .tier_item:hover {
      text-align: center;
      height: 36px;
      line-height: 36px;
      color: #feeb09 !important;
      background-color: #b92e32;
      border-radius: 100px;
    }
  }

  .show_wrap {
    position: relative;

    .cut_show_title {
      position: absolute;
      top: 0;
      left: 0;
      width: 255px;
      height: 75px;
      line-height: 75px;
      text-align: center;
      font-size: 30px;
      color: #fff;
      background-color: #000;
      opacity: 0.7;
    }

    img {
      width: 100vw;
      height: 600px;
    }
  }
}

// 品牌招商
.merchants_wrap {
  .merchants_item_box {
    // display: flex;
    padding-top: 70px;
    .merchants_item {
      padding: 0 36px;
      color: #b92e32;
      text-align: center;
      .merchant_number {
        width: 75px;
        height: 55px;
        margin: auto;
      }

      .transverse_line {
        width: 34px;
        height: 1px;
        background-color: #cdcdcd;
        margin: 20px auto;
      }

      .advantage_title {
        cursor: pointer;
        font-size: 18px;
        color: #333;
      }

      .advantage_title:hover {
        color: #b92e32;
      }

      .item_content {
        width: 325px;
        font-size: 14px;
        color: #666;
        line-height: 35px;
        margin: 40px auto 50px;
        text-align: center;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /*截取第三行*/
        overflow: hidden;
      }
      img {
        cursor: pointer;
        width: 328px;
        height: 204px;
      }
    }
  }
}

// pc版心
.type_area {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

// 入驻品牌层切换
.enter_active {
  text-align: center;
  height: 36px;
  line-height: 36px;
  color: #feeb09 !important;
  background-color: #b92e32;
  border-radius: 100px;
}

// bootstrap
.card-title {
  margin: 0;
}

.card {
  background-color: transparent;
}

.navbar-toggler {
  color: #fff !important;
  border: none;
}

@media screen and (max-width: 480px) {
  .header_wrap {
    height: 100%;
  }

  .type_area {
    width: 375px;
  }

  .logo_img {
    width: 180px !important;
    height: 45px !important;
    padding: 0.5rem 1rem !important;
  }

  .type_item {
    margin: 15px 0 !important;
    text-align: center;
  }

  // 通用
  .dynamic_wrap {
    padding: 25px 0;
  }

  .dynamic_item_wrap {
    padding: 15px 0;
    .dynamic_item {
      margin-bottom: 0;
      width: auto;
      // flex: 1 0 0%;
      img {
        width: 328px;
      }

      .card-body {
        padding: 0;
        margin-top: 0;
      }

      .item_title {
        padding: 10px 0;
        width: 325px;
      }

      .item_time {
        width: 325px;
      }

      .item_content {
        width: 325px;
        margin: 10px 0;
      }

      .item_arrows {
        width: 325px;
        padding-bottom: 10px;
      }
    }
  }

  .brand_wrap {
    .show_wrap {
      .cut_show_title {
        width: 128px;
        height: 35px;
        line-height: 35px;
        font-size: 16px;
      }

      img {
        width: 375px;
        height: auto;
      }
    }

    .cut_tier_wrap {
      padding: 30px 0;
      .tier_item {
        padding: 0 20px;
        margin: 0;
      }
    }
  }

  .merchants_item {
    padding: 0 !important;
  }

  // 品牌招商
  .merchants_wrap {
    .merchants_item_box {
      padding-top: 30px;
      .merchants_item {
        margin: 10px 0 20px;
        .item_content {
          margin: 15px auto 0;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) and (min-width: 480px) {
  .type_area {
    width: 640px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .type_area {
    width: 768px;
  }
}

/* 1024-1200px */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .type_area {
    width: 970px;
  }
}

/* 大于1200 px */
@media screen and (min-width: 1200px) {
  .type_area {
    width: 1200px;
  }
}
</style>
